import script from "./automatic-points-title.vue?vue&type=script&setup=true&lang=js"
export * from "./automatic-points-title.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__